import { useState, useEffect, useRef } from 'react';

const useVoiceDuration = () => {
  const [voiceDuration, setVoiceDuration] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const startTimeRef = useRef(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    return () => {
      clearInterval(intervalRef.current);
    };
  }, []);

  const startTimer = () => {
    startTimeRef.current = Date.now();
    intervalRef.current = setInterval(() => {
      const elapsedTime = Date.now() - startTimeRef.current;
      const hours = Math.floor(elapsedTime / (1000 * 60 * 60));
      const minutes = Math.floor((elapsedTime / (1000 * 60)) % 60);
      const seconds = Math.floor((elapsedTime / 1000) % 60);
      setVoiceDuration({ hours, minutes, seconds });
    }, 1000);
  };

  const stopTimer = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = null;
  };

  return { voiceDuration, startTimer, stopTimer };
};

export default useVoiceDuration;